import React from 'react';
import { Trans } from 'react-i18next';
import { ErrorMessage } from '@common/components/ErrorMessage';
import { useCandidateLink } from '@common/hooks/useCandidateLink';
import { LINK } from '@common/hooks/useCandidateLink';
import { useAppSelector } from '@store/hooks';
import { getLocalisation } from '@store/localisation';
import { Box } from '@components/Box';
import { ExternalLink } from '@components/ExternalLink';
import { Checkbox, Field } from '@components/FormElements';
import { Stack } from '@components/Stack';

type AgreeToTermsProps = {
  value: boolean;
  onChange: () => void;
  error?: string;
};

export const AgreeToTerms = (props: AgreeToTermsProps) => {
  const { value, onChange, error } = props;
  const { getCandidateLink } = useCandidateLink();
  const { brandNameText } = useAppSelector(getLocalisation);

  return (
    <Stack spacing="small">
      <Field
        label=""
        message={
          error && (
            <Box marginTop="xxsmall">
              <ErrorMessage>{error}</ErrorMessage>
            </Box>
          )
        }
      >
        <Box marginTop="xsmall">
          <Checkbox
            testID="agree-to-terms-checkbox"
            label={
              <Trans
                i18nKey="common.message.termsAndPrivacy.termsAndPrivacyConsent"
                values={{
                  brandNameText
                }}
                components={[
                  <ExternalLink
                    size="small"
                    testID="advertising-terms-of-use-link"
                    href={getCandidateLink(LINK.ADVERTISING_TERMS_OF_USE_PAGE)!}
                  >
                    0
                  </ExternalLink>,
                  <ExternalLink
                    size="small"
                    data-test-key="privacy-statement-link"
                    href={getCandidateLink(LINK.PRIVACY_PAGE)!}
                  >
                    1
                  </ExternalLink>
                ]}
              />
            }
            value={value}
            onChange={onChange}
          />
        </Box>
      </Field>
    </Stack>
  );
};
